import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  GeneracionCoordinadorAdministrativoDispatcher,
  generacionCoordinadorAdministrativoDispatcher
} from "./GeneracionCoordinadorAdministrativo.dispatcher";
import {
  GeneracionCoordinadorAdministrativoStore,
  generacionCoordinadorAdministrativoStore
} from "./GeneracionCoordinadorAdministrativo.store";
import GeneracionCoordinadorAdministrativoComponent from "../../../components/comisionesCoordinadorAdministrativo/generacion";

interface Props
  extends GeneracionCoordinadorAdministrativoStore,
    GeneracionCoordinadorAdministrativoDispatcher {}

@ReduxConnect(
  generacionCoordinadorAdministrativoStore,
  generacionCoordinadorAdministrativoDispatcher
)
export default class GeneracionCoordinadorAdministrativoContainer extends Component<
  Props
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Generación de Comisiones - Coordinador Administrativo" />
          <GeneracionCoordinadorAdministrativoComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
